import { render } from "./aio-login-pro-popup.vue?vue&type=template&id=63f5befb&scoped=true"
import script from "./aio-login-pro-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-pro-popup.vue?vue&type=script&lang=js"

import "./aio-login-pro-popup.vue?vue&type=style&index=0&id=63f5befb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f5befb"]])

export default __exports__